import { createContext, RefObject, useContext, useEffect } from 'react';

export const ContentPaneBottomInsetContext = createContext<(height: number) => void>(() => {});

/**
 * Reserves the height of an element pinned to the bottom of the content pane as the pane's
 * bottom scroll padding, so keyboard focus never lands behind it.
 */
export function useContentPaneBottomInset(elementRef: RefObject<HTMLElement | null>) {
  const setBottomInset = useContext(ContentPaneBottomInsetContext);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new ResizeObserver(() => {
      setBottomInset(Math.ceil(element.getBoundingClientRect().height));
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
      setBottomInset(0);
    };
  }, [elementRef, setBottomInset]);
}
